import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { API_URL } from '../constants';
import { IPagedResults } from '../core/interfaces';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class SiteService extends BaseDataService {
    public DISABLED_ID: number[] = [620];

    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public getSitesList(page: number, pageSize: number = 10, filter: any): Observable<IPagedResults<any>> {
        let url = `Site/GetAll`;
        return super.getAll<any>(url);
    }

    public checkIfHasSite(accountId: number): Observable<IPagedResults<any>> {
        let url = `Site/GheckIfHasSite?accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public getSitesByAccountList(id: number): Observable<IPagedResults<any>> {
        let url = `Site/GetByAccountId?id=${id}`;
        return super.getAll<any>(url);
    }

    public getByAccountIdAndUserId(accountId: number, userId: number, moduleId: number): Observable<IPagedResults<any>> {
        let url = `Site/GetByAccountIdAndUserId?accountId=${accountId}&userId=${userId}&moduleId=${moduleId}`;
        return super.getAll<any>(url);
    }

    public getByGuid(guid: any): Observable<IPagedResults<any>> {
        let url = `Site/GetByGuid?Guid=${guid}`;
        return super.getById<any>(url);
    }

    public getByAccountIdAndUserIdModuleArray(data) {
        let url = `Site/GetByAccountIdAndUserIdModuleArray`;
        return super.save<any>(url, data);
    }

    public getSite(id: number) {
        let url = `Site/Get?id=${id}`;
        return super.getById<any>(url);
    }

    public saveSite(data) {
        let url = `Site/Save`;
        return super.save<any>(url, data);
    }

    public deleteSite(data) {
        let url = `Site/Delete`;
        return super.save<any>(url, data);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/site.service.ts